import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resources } from './i18nResources'
import { LS_LOCALE } from './redux/keysStorage'

// Use same localStorage key as Redux to ensure consistent initialization
const storedLocale = localStorage.getItem(LS_LOCALE) || 'fi'

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  lng: storedLocale,
  fallbackLng: 'fi',
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default
    // format: (value, format, lng) => { // legacy usage
    //   if (value instanceof Date) {
    //     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
    //   }
    //   return value;
    // }
  },
  resources
})

export default i18n
